import { render, staticRenderFns } from "./rate-item.vue?vue&type=template&id=604a91ce&"
import script from "./rate-item.vue?vue&type=script&lang=js&"
export * from "./rate-item.vue?vue&type=script&lang=js&"
import style0 from "./rate-item.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "rate-item.vue"
export default component.exports